export default function calculateChartDate(countDate: number) {
  const timeInMilliseconds = 24 * 60 * 60 * 1000 * countDate;
  const dateToday: any = new Date();
  return {
    start: dateToday - timeInMilliseconds,
    finish: dateToday.getTime(),
  };
}
